module.exports = __webpack_public_path__ + "static/media/bd.6fa55e57.svg";